import { db } from '../../config/firebaseconfig'
import shortid from 'shortid'

export default function generateUniqueShortId() {
  const newId = shortid.generate()
  return new Promise((resolve, reject) => {
    db.collection('registrationCodes').doc(newId).get()
      .then((doc) => {
        if (doc.exists) {
          resolve(generateUniqueShortId())
        } else {
          resolve(newId)
        }
      })
      .catch((err) => reject(err))
  })
}




// WEBPACK FOOTER //
// ./src/helpers/users/generateUniqueShortId.js